export default __webpack_public_path__ + "static/tulika-ranjan-2256caed58dcd6152724da7a26fad1a8.jpg";